<template>
  <b-modal
    ref="actions-modal"
    title="Actions pour la boucle"
    hide-footer
    size="xl"
  >
    <div class="container-fluid my-3">
      <div v-show="!displayNewAction">
        <b-button-group 
          v-for="(action, index) in actions"
          :key="index"
          class="action-button m-2"
        >
          <b-button>
            <i
                class="fa"
                :class="{'fa-phone': action.action_type === 'SMS', 'fa-envelope': action.action_type === 'EMAIL'}"
            ></i>
            {{action.recipient}}
            <b-badge
              pill
              variant="light"
              class="mr-2"
              v-for="(cond, index) in action.conditions"
              :key="index"
            >
              {{cond.andon_type}}
            </b-badge>
          </b-button>
          <b-button variant="danger" @click="removeAction(action)">
            <i class="fa fa-times"></i>
          </b-button>
        </b-button-group>
        <span mr-4></span>
        <b-button pill variant="success" @click="toggleNewAction(true)">
          <i class="fa fa-plus"></i>
        </b-button>
      </div>
      <div v-show="displayNewAction">
        <b-row align-h="end">
          <b-col cols="6">
            <h2>Nouvelle action</h2>
          </b-col>
          <b-col cols="2">
            <b-button pill variant="danger" @click="toggleNewAction(false)">
              <i class="fa fa-times"></i>
            </b-button>
          </b-col>
        </b-row>
        <div>
          <b-row>
            <b-col sm="4">
              <b-form-group label="Action">
                <b-form-radio-group
                  id="btn-radios-2"
                  v-model="form.action_type"
                  :options="actionType"
                  button-variant="outline-primary"
                  size="md"
                  name="radio-btn-outline"
                  buttons
                ></b-form-radio-group>
              </b-form-group>
              <b-form-group label="Conditions">
                <b-form-checkbox-group
                  v-model="form.conditions"
                  :options="actionConditions"
                  switches
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
            <b-col sm="6" v-show="form.action_type.length > 0">
              <b-row>
                <b-col>
                  Destinataire
                  <b-form-input
                    v-model="form.recipient"
                    :state="validRecipient"
                    :placeholder="placeholder"
                    trim
                  ></b-form-input>
                </b-col>
              </b-row>
              <br>
              <b-row>
                <b-col>
                  Message
                  <b-form-input
                    v-model="form.message"
                    :state="validMessage"
                    placeholder="..."
                    trim
                  ></b-form-input>
                </b-col>
              </b-row>
              <br>
              <b-row>
                <b-col>
                  <b-button
                    variant="primary"
                    :disabled="!formFielded()"
                    @click="addAction"
                    >
                    Créer
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </div>
      <!-- <b-form>
        <b-form-group
          label="Nouveau nom"
        >
          <b-form-input
            type="text"
            v-model="newDescription"
          />
        </b-form-group>
      </b-form> -->
        <!-- <div class="row justify-content-center mt-4">
          <b-button
            variant="outline-danger"
            class="mr-5"
            >Annuler</b-button
          >
          <b-button
            variant="primary"
            @click="hideModal()"
            >
            Valider
          </b-button>
        </div> -->
      </div>
  </b-modal>
</template>
<script>
import server from '../api/server.vue'

export default {
  name: 'edit-loop-name-modal',
  props: [],
  data() {
    return {
      displayNewAction: false,
      loop: null,
      actions: ['aaa', 'bbb'],
      actionType: ['SMS', 'EMAIL'],
      actionConditions: ['LEATTIME_EXCED', 'TOO_MUCH_DOCUMENT'],
      actionId: '',
      isNew: true,
      form: {
        action_type: '',
        conditions: [],
        recipient: '',
        message: '',
      }
    }
  },
  computed: {
    validRecipient () {
      if (this.form.action_type === 'SMS') {
        const phoneRegExp = /(\+[1-9]{2})[ ]?[0-9]{1}[ ]?[0-9]{2}[ ]?[0-9]{2}[ ]?[0-9]{2}[ ]?[0-9]{2}$/
        return (phoneRegExp.exec(this.form.recipient) !== null)
      } else if (this.form.action_type === 'EMAIL') {
        const emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return (emailRegexp.exec(this.form.recipient) != null)
      }
      return false
    },
    validMessage () {
      return (this.form.message.length > 0 && this.form.message.length < 280)
    },
    placeholder () {
      if (this.form.action_type === 'SMS') {
        return '+33612345678'
      } else if (this.form.action_type === 'EMAIL') {
        return 'test@monentreprise.com'
      } else {
        return ''
      }
    },
  },
  methods: {
    formFielded () {
      return (
        !_.isEmpty(this.form.action_type) &&
        !_.isEmpty(this.form.recipient) &&
        !_.isEmpty(this.form.message) &&
        !_.isEmpty(this.form.conditions) &&
        this.validRecipient &&
        this.validMessage
      )
    },
    resetForm () {
      this.form = {
        action_type: '',
        recipient: '',
        message: '',
        conditions: [],
      }
    },
    toggleNewAction (value) {
      this.resetForm()
      this.displayNewAction = value
      this.isNew = true
    },
    toggleUpdateACtion (actionId) {
      this.isNew = false
      this.actionId = action.uniqid
      this.form.action_type = action.action_type
      this.form.recipient = action.recipient
      this.form.message = action.message
      for (const cond of action.conditions) {
        this.form.conditions.push(cond.andon_type)
      }
    },
    removeAction (action) {
     server.deleteAction(action.uniqid)
      .then(() => {
        this.$toasted.success('Action supprimée')
        this.getActions()
      })
      .catch((e) => { this.$toasted.error(e.message) })
    },
    addAction () {
      this.sendingData = true
      this.form.recipient.replaceAll(' ', '')
      const params = { ...this.form, equipment_id: this.equipmentId }
      if (this.isNew) {
        server.addActions(params, this.loop.uniqid)
          .then(result => {
            this.$toasted.success('Action ajoutée !')
            this.resetForm()
            this.getActions()
            this.displayNewAction = false
          })
          .catch((e) => { this.$toasted.error(e.message) })
          .finally(() => { this.sendingData = false })
      } else {
        server.updateAction(this.actionId, params)
          .then(result => {
            this.$toasted.success('Action mise à jour !')
            this.$emit('action-saved')
            this.hide()
          })
          .catch((e) => { this.$toasted.error(e.message) })
          .finally(() => { this.sendingData = false })
      }
    },
    getActions () {
      if(!this.loop){
        return
      }
      server.getActions(this.loop.uniqid).then((result) => {
        this.actions = result.data
      })
    },
    hideModal () {
      this.$refs['actions-modal'].hide()
    },
    showModal (loop) {
      this.loop = loop
      this.getActions()
      this.$refs['actions-modal'].show()
    },
  },
}
</script>

<style lang="scss">
.action-button {
  margin-right: 10px;
}


</style>



// WEBPACK FOOTER //
// src/components/ActionsModal.vue